import React, { Component } from 'react';
import './ChooseGroupPopup.css';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import mainAPI from '../../api/MainAPI';
import Label from '../../components/label/Label';

export default class ChooseGroupPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.getGroups();
	}

	getGroups = async () => {
		let groups = await mainAPI.user_group.for_user();
		this.setState({ groups });
	};

	setGroup = (id) => {
		localStorage.user_group_id = id;
		if(!localStorage.num_additional_groups){
			// TODO: We shouldn't have to do this.
			// Same with the disabling "no-use-before-define" rules in the .eslintrc.js file
			// I think we need to update our eslint settings, but not sure I want to
			// get into that right now.
			// eslint-disable-next-line no-restricted-globals, no-undef
			localStorage.num_additional_groups = this.state?.groups?.length || 2;
		}
		const urlParams = new URLSearchParams(window.location.search);
		let returnURL = urlParams.get('return-url');
		if (returnURL) {
			window.location = returnURL;
		} else {
			window.location = '/';
		}
	};

	renderGroups = () => {
		let toDisplay = [];
		for (let i in this.state.groups) {
			let group = this.state.groups[i];
			toDisplay.push(
				<Label
					tabIndex="0"
					className="row"
					key={group.id}
					onClick={() => {
						this.setGroup(group.id);
					}}
					black
				>
					{group.name}
				</Label>
			);
		}
		return <div className="scrolling-list">{toDisplay}</div>;
	};

	render() {
		return (
			<Popup {...this.props} show={this.props.show} className="g-choose-group-popup">
				<Card>
					<Label larger black>
						Choose an Agency
					</Label>
					{this.renderGroups()}
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/chooseGroupPopup/ChooseGroupPopup.jsx